module.exports = __webpack_public_path__ + "static/media/comida.0189119b.jpg";